import { Helmet } from 'react-helmet-async'

type Props = {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
}

const Seo = (props: Props) => {
  const {
    title = 'ILLUSTAR FES - 일러스타 페스',
    description = '함께 만들어나가는 종합 서브컬쳐 이벤트 일러스타 페스',
    keywords = 'ILLUSTARFES, 일러스타페스, 서브컬쳐, 서브컬쳐, 코스프레, 동인지',
    image = `${import.meta.env.VITE_STATIC_ENDPOINT}/metadata/og-default.webp`,
    url = import.meta.env.VITE_REDIRECT_URI,
  } = props

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="canonical" href={url} />
    </Helmet>
  )
}

export default Seo
